import createStyle from "@josephmark/createstyle"

export const Container = createStyle("div", "mx-auto w-full max-w-[calc(var(--spacing)*248)] px-5 xl:px-14")

export const FullContainer = createStyle("div", "w-full px-5 xl:px-14")

export default Container
